module.exports = __webpack_public_path__ + "img/access_restriction.ffa82552.png";